'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, useRef } from 'react';
import BrandNode from '@/components/ServicesLobbyPage/BrandEvolutionSection/BrandNode';
import { CURRENT_BRAND_NODE, NEW_BRAND_NODE } from '@/components/ServicesLobbyPage/BrandEvolutionSection/const';
import EvolutionBeams from '@/components/ServicesLobbyPage/BrandEvolutionSection/EvolutionBeams';
import RevealCurtain from '@/components/ServicesLobbyPage/BrandEvolutionSection/RevealCurtain';
import useRevealCurtainAnimation from '@/components/ServicesLobbyPage/BrandEvolutionSection/useRevealCurtainAnimation';
import useDevice from '@/hooks/useDevice';
import { useLazyVideoSource } from '@/hooks/useLazyVideoSource';
import { useViewportVideosPlayback } from '@/hooks/useViewportVideosPlayback';
import css from './style.module.scss';
const BrandEvolutionSection: FC = () => {
  const $ = _c(14);
  const device = useDevice();
  const isMobile = device === "mobile";
  const sectionRef = useRef(null);
  const curtainRef = useRef(null);
  const shouldLoadVideo = useLazyVideoSource(sectionRef);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [sectionRef];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useViewportVideosPlayback(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      sectionRef,
      curtainRef
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useRevealCurtainAnimation(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("container", css.wrapper);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== shouldLoadVideo) {
    t3 = <BrandNode className={css.currentBrandNode} data={CURRENT_BRAND_NODE} shouldLoadVideo={shouldLoadVideo} />;
    $[3] = shouldLoadVideo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EvolutionBeams />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== shouldLoadVideo) {
    t5 = <BrandNode className={css.newBrandNode} data={NEW_BRAND_NODE} shouldLoadVideo={shouldLoadVideo} />;
    $[6] = shouldLoadVideo;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isMobile) {
    t6 = !isMobile && <RevealCurtain ref={curtainRef} />;
    $[8] = isMobile;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t6) {
    t7 = <section ref={sectionRef} className={t2}>{t3}{t4}{t5}{t6}</section>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default BrandEvolutionSection;